'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = HotelTypeDescriptionPanel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HotelTypeDescriptionPanel(props) {
  var components = props.components,
      description = props.description,
      meal = props.meal,
      roomView = props.roomView,
      bedType = props.bedType,
      refundableText = props.refundableText,
      t = props.t;


  var styleHotelRoomContainer = (0, _emailStyleTools.containerStyles)(components, 'HotelRoomContainer');
  var styleHotelRoomLabel = (0, _emailStyleTools.textStyles)(components, 'HotelRoomLabel');

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'HotelTypeDescriptionPanel' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleHotelRoomContainer, _emailStyleTools.padTen) },
          _react2.default.createElement(
            'span',
            { style: styleHotelRoomLabel },
            description
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleHotelRoomContainer, _emailStyleTools.padTen) },
          _react2.default.createElement(
            'span',
            { style: styleHotelRoomLabel },
            t('hotel.bed'),
            ':',
            bedType,
            ' ',
            t('hotel.meal'),
            ':',
            meal,
            ' ',
            t('hotel.view'),
            ':',
            roomView
          )
        )
      ),
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleHotelRoomContainer, _emailStyleTools.padTen) },
          refundableText && refundableText.map(function (text, i) {
            return _react2.default.createElement(
              'div',
              { key: i },
              _react2.default.createElement(
                'span',
                { style: (0, _extends3.default)({}, styleHotelRoomLabel) },
                text
              ),
              _react2.default.createElement('br', null)
            );
          })
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Hotel/Email/Active/HotelTypeDescriptionPanel.jsx
// module id = 1526
// module chunks = 0